import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TiDraggableDirective } from './common/ti.draggable.directive';

import { TiSplitterComponent } from './splitter/ti.splitter.component';
import { TiSplitterBarComponent } from './splitter/ti.splitter-bar.component';
/*import { SplitterPaneComponent } from '../../../../kendo/kendo-angular-layout/splitter/splitter-pane.component';*/
import { TiSplitterPaneComponent } from './splitter/ti.splitter-pane.component';

const exportedModules = [TiSplitterComponent, TiSplitterPaneComponent];

const declarations = [TiDraggableDirective, TiSplitterBarComponent, ...exportedModules];

/**
 * Represents the [NgModule](https://angular.io/docs/ts/latest/guide/ngmodule.html)
 * definition for the Splitter component.
 *
 * The module registers:
 * - `SplitterComponent`&mdash;The `Splitter` component class.
 * - `SplitterPaneComponent`&mdash;The `SplitterPane` component class.
 */
@NgModule({
  declarations: [declarations],
  exports: [exportedModules],
  imports: [CommonModule],
})
export class TiSplitterModule {}
